<script>
  export default {
    name: 'global-title',
    props: ['title'],
    watch: {
      title: {
        immediate: true,
        handler() {
          document.title = this.title + ' - Oldevuuren'
        }
      }
    },
    // eslint-disable-next-line
    render(createElement, context) {
      // We're disabled lint because this is a renderless component
    }
  }
</script>
